import { z } from 'zod';
import { permissionRolesFiltersSchema } from './permissions.schemas';

export const permissionCategories = [
  'employees',
  'benefitsAndDiscounts',
  'orders',
  'communication',
  'employeeRecognition',
  'system',
] as const;
export type PermissionCategory = (typeof permissionCategories)[number];

export const permissionNames = [
  'employees',
  'groups',
  'benefits',
  'discounts',
  'internalMerch',
  'internalMerchOrders',
  'melpShopOrders',
  'expenses',
  'expenseCompensations',
  'news',
  'surveys',
  'trainings',
  'feedbackInbox',
  'employeeRecognition',
  'automations',
  'companies',
  'generalSettings',
  'integrations',
  'administrators',
  'transmissionActs',
  'systemLog',
] as const;
export type PermissionName = (typeof permissionNames)[number];

export const accessLevels = [0, 1, 2] as const;
export type AccessLevel = (typeof accessLevels)[number];

export const roleTypes = ['admin', 'superAdmin', 'custom'] as const;
export type RoleType = (typeof roleTypes)[number];

export interface Permission {
  permission: PermissionName;
  category: PermissionCategory;
}

export interface RolePermission extends Permission {
  accessLevel: AccessLevel;
}

export interface PermissionCategoryGroup<T extends Permission = Permission> {
  category: PermissionCategory;
  permissions: T[];
}

export interface AdminRoleDetails {
  id: string;
  name: string;
  description: string;
  roleType: RoleType;
  isSystem: boolean;
  permissions: RolePermission[];
  categories: PermissionCategoryGroup<RolePermission>[];
}

export interface Role extends AdminRoleDetails {
  adminCount: number;
  integrationCount: number;
}

export type PermissionRolesFilters = z.infer<
  typeof permissionRolesFiltersSchema
>;
